let API_BASE_URL = '';

if (process.env.NODE_ENV === 'production') {
  API_BASE_URL = 'https://kotya.space';
} else {
  const hostname = window.location.hostname;
  if (hostname === 'localhost') {
    API_BASE_URL = 'http://localhost:3001';
  } else {
    API_BASE_URL = `http://${hostname}:3001`;
  }
}

export default API_BASE_URL;